'use client';

import React, { useEffect, useState } from 'react';
import style from './Header.module.scss';
import Link from 'next/link';
import { useAppStore } from '@/store/app/appStore';
import ProfileMenu from '@/components/Header/components/ProfileMenu';
import * as apiAuth from '@/api/auth';

export function Header(): React.JSX.Element | null {
  const { appState, setProfile } = useAppStore();
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [mounted, setMounted] = useState(false); // для того чтобы не рендерить компонент до монтирования

  useEffect(() => {
    setMounted(true); // гарантируем, что компонент смонтирован

    apiAuth.account()
      .then(acc => {
        setProfile(acc);
      })
      .catch(() => {
        // Можно раскомментировать если нужно сбросить сессию
        // localStorage.removeItem('tokenSession');
        // logout();
      })
      .finally(() => setCheckingAuth(false));
  }, []);

  // Этот эффект срабатывает только на клиенте, чтобы обработать скролл
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const onScroll = () => setScrolled(window.scrollY > 20);
      window.addEventListener('scroll', onScroll);

      return () => window.removeEventListener('scroll', onScroll);
    }
  }, []);

  const profile = appState.profile;

  // Если компонент еще не смонтирован, возвращаем null, чтобы избежать гидратации
  if (!mounted) return null;

  return (
    <header className={`${style.block} ${scrolled ? style.scrolled : ''}`}>
      <div className={style.container}>
        <div className={style.wrapper}>
          <div className={style.logo}>
          </div>

          <nav className={style.menu}>
          </nav>
        </div>

        <div className={style.profile}>
          {checkingAuth ? (
            <div className={style.skeletonProfile}>
              <div className={style.skeletonAvatar} />
              <div className={style.skeletonButton} />
            </div>
          ) : profile ? (
            <ProfileMenu profile={profile} />
          ) : (
            <Link href="/login" className={style.loginBtn}>
              Sing in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
